/**
 * HARD KILL Nova Poshta
 * Safe to comment out
 */

(function () {
  'use strict';

  /* =========================
     0. RESTORE FLAG ASAP
     (SYNC, BEFORE ANY NP CODE)
  ========================= */

  try {
    window.__KILL_NP__ = localStorage.getItem('__KILL_NP__') === '1';
  } catch (e) {
    window.__KILL_NP__ = false;
  }

  /* =========================
     1. HARD BLOCK CONSTRUCTOR
     (WITH RETRY)
  ========================= */

  function blockShippingApp() {
    const Original = window.ShippingComponentApp;

    if (!Original || Original.__hardBlocked) return false;

    function BlockedShippingComponentApp(...args) {
      if (window.__KILL_NP__) {
        console.log('[NP] constructor HARD blocked');
        return {};
      }
      return new Original(...args);
    }

    BlockedShippingComponentApp.prototype = Original.prototype;
    BlockedShippingComponentApp.__hardBlocked = true;

    window.ShippingComponentApp = BlockedShippingComponentApp;
    return true;
  }

  // retry until NP appears
  const blockInterval = setInterval(() => {
    if (blockShippingApp()) {
      clearInterval(blockInterval);
    }
  }, 0);

  /* =========================
     2. PATCH RENDER METHODS
     (SECOND LINE OF DEFENSE)
  ========================= */

  function patchPrototype() {
    const proto = window.ShippingComponentApp?.prototype;
    if (!proto || proto.__patched) return;

    ['renderForCart', 'renderForDrawer', 'render'].forEach(method => {
      if (!proto[method]) return;

      const original = proto[method];
      proto[method] = function (...args) {
        if (window.__KILL_NP__) {
          console.log('[NP] render blocked:', method);
          return;
        }
        return original.apply(this, args);
      };
    });

    proto.__patched = true;
    console.log('[NP] prototype patched');
  }

  /* =========================
     3. DOM HARD CLEAN
     (REMOVE NP ROOT ALWAYS)
  ========================= */

  function removeNovaPoshtaDOM() {
    if (!window.__KILL_NP__) return;

    document.querySelectorAll(
      '.shipping-component,' +
      '.nova-poshta,' +
      '[data-shipping*="nova"]'
    ).forEach(el => {
      el.remove();
      console.log('[NP] DOM removed');
    });
  }

  /* =========================
     4. FORCE CHECKOUT BUTTON
  ========================= */

  function forceCheckoutButton() {
    if (!window.__KILL_NP__) return;

    document.querySelectorAll(
      '.shipping-component__checkout'
    ).forEach(btn => btn.style.display = 'none');

    document.querySelectorAll(
      'form[action="/checkout"] [type="submit"], a[href="/checkout"]'
    ).forEach(btn => btn.style.display = '');
  }

  /* =========================
     5. OBSERVER (FINAL CONTROL)
  ========================= */

  const observer = new MutationObserver(() => {
    patchPrototype();
    removeNovaPoshtaDOM();
    forceCheckoutButton();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  /* =========================
     6. INIT
  ========================= */

  document.addEventListener('DOMContentLoaded', () => {
    patchPrototype();
    removeNovaPoshtaDOM();
    forceCheckoutButton();
  });

})();
